import React from 'react';
import {DefaultCell} from '../Table';

const OutOfService = ({
  action,
  setServiceModalStatus,
  setCurrentService,
  rowIndex,
  cellKeys,
}) => {
  // Avoiding to add new props
  const service = action;

  const rowClick = () => {
    setServiceModalStatus(true);
    setCurrentService(service);
  };

  return (
    <tr
      className='table-row'
      key={action.id}
      style={{
        gridTemplateColumns: `repeat(${cellKeys.length}, 1fr)`,
      }}
      onClick={rowClick}
    >
      <DefaultCell
        value={service?.title ? service?.title : '---'}
        index='name'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={service?.type ? service?.type : '---'}
        index='equipment'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={service?.facility ? service?.facility : '---'}
        index='facility'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={service?.reason ? service?.reason : '---'}
        index='inspection_date'
        rowIndex={rowIndex}
      />
    </tr>
  );
};

export default OutOfService;
